import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { useTranslation } from 'react-i18next';

import '../style/homeCarousel.css'

function HomeCarousel() {
    const { t } = useTranslation();
    
    const heroData = [
      {
        id: 1,
        image: require('../assets/images/ai-data-science.png'),
        titleKey: 'carousel.dataAI.title',
        descriptionKey: 'carousel.dataAI.description',
        linkKey: 'carousel.dataAI.link',
        link: '/services/data-ai'
      },
      {
        id: 2,
        image: require('../assets/images/task-automation-gemini.png'),
        titleKey: 'carousel.automation.title',
        descriptionKey: 'carousel.automation.description',
        linkKey: 'carousel.automation.link',
        link: '/services/automation'
      },
      {
        id: 3,
        image: require('../assets/images/webapp-dev-gemini.png'),
        titleKey: 'carousel.development.title',
        descriptionKey: 'carousel.development.description',
        linkKey: 'carousel.development.link',
        link: '/services/dev'
      }
    ];

    return (
      <section id="home" className="hero-block">
         <Carousel>
            {
              heroData.map(hero => {
                return (
                  <Carousel.Item key={hero.id}>
                    <img
                      className="d-block w-100"
                      src={hero.image}
                      alt={t(hero.titleKey)}
                    />
                    <Carousel.Caption>
                      <h2>{t(hero.titleKey)}</h2>
                      <p>{t(hero.descriptionKey)}</p>
                      <a className="btn btn-primary" href={hero.link}>{t(hero.linkKey)} <i className="fas fa-chevron-right"></i></a>
                    </Carousel.Caption>             
                  </Carousel.Item>
                );
              })
            }
        </Carousel>
      </section>
    );
  }

export default HomeCarousel;